<style>
    .myDialogClass{
        border-radius: 12px!important;
        width: 480px!important;
    }
</style>

<style src="../../../static/css/login_input.css" scoped></style> 
<template>
  <div>
    <el-dialog
        :visible.sync="show"
        custom-class="myDialogClass"
        @close="beforeClose()"
        >
        <div>
            <div class="login-title-text" style="text-align: center; margin-top: 0px !important;">
                {{ $t("LoginObject.title") }}
            </div>
            <el-form :model="loginForm" :rules="rules" ref="LoginFormRef">
                <el-form-item prop="account">
                    <div class="login-account">
                        <el-input v-model="loginForm.account" :placeholder="$t('LoginObject.accountPlaceHolder')">
                            <i slot="prefix">
                                <hsimage :src="account_prefix" class="prefix-image"></hsimage>
                            </i>
                    </el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="password">
                    <div class="login-password">
                        <el-input v-model="loginForm.password" type="password" :placeholder="$t('LoginObject.passwordPlaceHolder')">
                            <i slot="prefix">
                                <hsimage slot name="prefix" :src="password_prefix" class="prefix-image"></hsimage>
                            </i>
                        </el-input>
                    </div>
                </el-form-item>
                <div class="login-button">
                    <el-button  type="primary" style="font-size: 16px; width: 100%;" @click="onClicKLogin">{{ $t("LoginObject.name") }}</el-button>
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between">
                    <el-checkbox v-model="loginForm.rememberMe" style="color: #B6B6B6;margin-top: 10px;">{{ $t("LoginObject.remember") }}</el-checkbox>
                
                    <el-button type="text" style="color: #B6B6B6" @click="onClickForegetPassword">{{ $t("LoginObject.forget") }}</el-button>
                </div>
            </el-form>
        </div>
    </el-dialog>
    <el-dialog 
        :visible.sync="forgetShow"
        custom-class="myDialogClass"
        @close="forgetClose"
        >
        <div class="login-title-text" style="text-align: center; margin-top: 0px !important;">
                {{ $t("LoginObject.resetTitle") }}
            </div>
        <el-form :model="forgetForm" ref="ResetForm" :rules="forgetrules">
            <el-form-item prop="nickName">
                <div class="login-account-input" style="margin-top: 16px;">
                    <el-input v-model="forgetForm.nickName" :placeholder="$t('LoginObject.accountPlaceHolder')"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="email">
                <div class="login-account-input" style="margin-top: 16px;">
                    <el-input v-model="forgetForm.email" :placeholder="$t('LoginObject.emailPlaceHolder')"></el-input>
                </div>
            </el-form-item>
        </el-form>
        <div style="color: #B6B6B6; font-size: 14px; text-align: start; margin-top: 16px;">{{$t('LoginObject.emailTips')}}</div>
        <div class="login-button" style="margin-top: 16px;">
            <el-button  type="primary" style="font-size: 16px; width: 100%;" @click="onClicKSend">{{ $t('CommonObject.sendEmail') }}</el-button>
        </div>
        <div style="margin-top: 12px;">
            <el-button type="text" style="font-size: 16px; width: 100%; color: #B6B6B6;" @click="onClicKReturn">{{ $t('CommonObject.back') }}</el-button>
        </div>
    </el-dialog>
  </div>
  
</template>

<script>
import hsimage from './hsimage.vue'

export default {
    name:'MyAlert',
    props:{
        visible:Boolean,
    },
    components:{
        hsimage
    },
    data () {
        return {
            show:false,
            loginForm :{
                account:"",
                password:"",
                rememberMe:true,
            },
            rules:{
                password: [
                {required:true, message: this.$t('LoginObject.passwordRequire'), trigger: "blur" },
                {required: true, min: 6, message: this.$t('LoginObject.passwordLimit') ,trigger: "blur"}
                ],
                account:[{required:true,message: this.$t("LoginObject.accountRequire")}]
            },
            account_prefix: require('./../../../static/images/login/account_prefix.png'),
            password_prefix: require('./../../../static/images/login/password_prefix.png'),

            // 忘记密码

            forgetShow:false,
            forgetForm:{
                email:'',
                nickName:''
            },
            lastSuccessForm: undefined, // 上一次发送成功之后的表单
            lastSuccessTime: 0, // 上一次发送成功的时间戳
            forgetrules:{
                email:[{
                    required:true,message:'',trigger: "blur",validator:this.emailValidate
                }],
                nickName:[{
                    required:true,message: this.$t('LoginObject.accountPlaceHolder'),trigger: "blur"
                }]
            }

        }
    },
    mounted(){
        this.rules = {
            password: [
            {required:true, message: this.$t('LoginObject.passwordRequire'), trigger: "blur" },
            {required: true, min: 6, message: this.$t('LoginObject.passwordLimit') ,trigger: "blur"}
            ],
            account:[{required:true,message: this.$t("LoginObject.accountRequire")}]
        }
    },
    methods:{
        beforeClose(val){
            this.$refs.LoginFormRef.clearValidate()
            this.$refs.LoginFormRef.resetFields()
            this.show = false
            this.$emit('close',this.show)
        },
        onClicKLogin(){
            this.$refs.LoginFormRef.validate((pass)=>{
                if(pass){
                    this.doLogin()
                }
            })
        },
        doLogin(){
            let params = {
                username: this.loginForm.account,
                password: this.loginForm.password

            }
            this.$request.post('/user/login',{},{params:params}).then(response=>{
                if(response.data.code == 200){
                    // console.log('登录用户信息：',response.data)
                    this.afterLoginSuccess(response.data)
                    this.$toastSuccess(this.$t('LoginObject.success'))
                }else {
                   this.$toastError(this.$t('LoginObject.fail'))
                }
            }).catch(err=>{
                // console.log(err)
                this.$toastError(this.$t('LoginObject.error'))
            })
        },
        afterLoginSuccess(data){
            this.show = false

            this.$store.commit('saveUserInfo',data.data) // vuex 
            this.$store.commit('saveLoginToken',data.token)
            this.$localStore.saveUserInfo(data.data)
            this.$localStore.saveLoginToken(data.token)
            this.$localStore.saveTokenExpireTime(data.expireTime)
            this.$bus.$emit("LOGIN_STATE_CHANGED",true)

            // 发送刷新购物车通知
            this.$bus.$emit("RELOAD_SHOPPINGCART_DATA") // 发送刷新购物车通知
             
            //发送比赛开始通知
            // let goingMatch = data.goingMatch

            let expir = data.data.expirationMill
            let code = this.$timeUtils.calcExpiration(expir)
            // console.log('过期时间：', expir)
            if(code == 0){
                this.$alert(this.$t('LoginObject.accountExpir') + expir + this.$t('LoginObject.accountEnd') + this.$t('LoginObject.accountExpirsubfix'), this.$t('CommonObject.tipTitle'), {
                    confirmButtonText: this.$t('CommonObject.ok'),
                    confirmButtonClass: 'confirm-button-class',
                    type:'warning',
                    // callback: action => {
                    //     this.jumpToFromWhere(goingMatch)
                        
                    // }
                });
        
            }else if(code < 0){
                this.$alert(this.$t('LoginObject.accountExpired') + this.$t('LoginObject.accountExpirsubfix'), this.$t('CommonObject.warnTitle'), {
                    confirmButtonText: this.$t('CommonObject.ok'),
                    confirmButtonClass: 'confirm-button-class',
                    type:'warning',
                    callback: action => {
                        // this.jumpToFromWhere(goingMatch)        
                    }
                });
            }else {
                // this.jumpToFromWhere(goingMatch)
            }
        },
        // 从哪里来，跳到哪里去
        // jumpToFromWhere(goingMatch){
        //     if(this.fromRoute != undefined){
        //         let json =  JSON.stringify(this.fromRoute)
        //         this.$router.replace({path :'/index',params:{backData:json,goingMatch:goingMatch}}).catch(err=> {  
        //             console.log('error')
        //         })
        //     }else {
        //         this.$router.replace({path:"/index",params:{goingMatch:goingMatch}}).catch(err=> {  
        //             console.log('error')
        //         })
        //     }
        // },
        //注册新用户
        onClickRegistNewUser(){
            // this.$emit('operationChanged',{type:'new_user',data:undefined})
        },
        //忘记密码
        onClickForegetPassword(){
            this.forgetShow = true
            this.$refs.ResetForm.clearValidate()            
        },
        forgetClose(){
            this.forgetShow = false
        },
        onClicKReturn(){
            this.forgetClose()
            this.show = true
        },
        // 邮箱验证
        emailValidate(rule,value,callback){
            const mal = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
            if (rule.required && !value) {
                return callback(new Error(this.$t('LoginObject.emailPlaceHolder')))
            }
            if (value) {
                if (!(mal.test(value))) {
                callback(new Error(this.$t('LoginObject.emailInvalidate')))
                } else {
                callback()
                }
            }
        },
        onClicKSend(){
            this.$refs.ResetForm.validate((pass)=>{
                if(pass){
                    if(!this.checkCanSend()){
                        this.$toastWarning(this.$t('CommonObject.tomuch'))
                        return;
                    }
                    //调用发送邮箱接口
                    let body = JSON.parse(JSON.stringify(this.forgetForm));
                    this.$request.get('/user/sendResetPswEmail',body).then(response=>{
                        // console.log(response)
                        if(response.data.code == 200){
                            this.$toastSuccess(this.$t('LoginObject.emailSend'))
                            this.lastSuccessForm = body
                            this.lastSuccessTime = new Date().getTime()
                        }else{
                            let msg = response.data.msg
                            this.$toastError(msg)
                        }
                    }).catch(err=>{
                        console.log(err)
                        this.$toastError('error')
                    })
                }
            })
        },
        checkCanSend(){
            if(this.lastSuccessForm == undefined){
                return true
            }
            let last = JSON.stringify(this.lastSuccessForm)
            let current = JSON.stringify(this.forgetForm)
            if(last != current){
                return true
            }
            // 判断时间
            let now = new Date().getTime()
            if(now - this.lastSuccessTime > 60 * 1000){
                return true
            }
            return false
        },
    },
    watch:{
        visible:{
            handler(newVal,oldval){
                this.show = newVal
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/login_dialog.vue